import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import LocationTime from '@rsos/components/capstone/DataCards/DataCardLocation/LocationTime';
import { Box, Accordion } from '@rsos/components/capstone/base';
import Altitude from './Altitude';
import EstimatedAddressLabel from './EstimatedAddressLabel';
import LatLong from './LatLong';
import CallerLocationAddress from './LocationAddress';
import Uncertainty from './Uncertainty';
import What3words from './What3words';
import {
  SingleWrapper,
  CircleAndLine,
  Circle,
  Line,
  InfoWrapper,
  SingleLocationWrapper,
} from './styles/singleHistoricLocation.styles';

const SingleHistoricLocation = memo(({ location, locationIndex }) => {
  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );
  const indoorLocation = location.rg_exact_location || location.rg_floor;
  const timeStamp = parseFloat(location.location_time);
  const { irpVersion } = useSelector(state => state.sinatra.irp);
  const rgAddressProvider = location?.rgAddressProvider;

  return (
    <SingleWrapper>
      <Accordion
        margin="0"
        headerPadding="0"
        btnSize="xsmall"
        btnPx="6px"
        noBorder
        header={
          <SingleLocationWrapper horizontal>
            <CircleAndLine>
              <Circle isCall />
              <Line isCall />
            </CircleAndLine>
            <InfoWrapper>
              <LocationTime
                {...{ timeStamp }}
                color="success"
                noDate
                size="small"
                timeAgoTextSize="small"
                timeBoxTextSize="xsmall"
              />
              <CallerLocationAddress
                {...{ selectedCallerID }}
                locationIndex={locationIndex}
                isHistoricLocation
                isCompact
              />
            </InfoWrapper>
          </SingleLocationWrapper>
        }
        interactionType="button"
        height={180}
        width="100%"
        padding="0"
        justify="flex-start"
        content={
          <Box>
            <LatLong
              longitude={location.longitude}
              latitude={location.latitude}
              irpVersion={irpVersion}
            />
            <What3words isHistoricLocation location={location} />
            <Uncertainty
              uncertaintyRadius={location.uncertainty_radius}
              confidence={location.uncertainty_confidence}
            />
            <Altitude
              altitude={location.altitude}
              indoorLocation={indoorLocation}
              altitudeUncertaintyRadius={location.altitude_uncertainty_radius}
            />
          </Box>
        }
      ></Accordion>
      <EstimatedAddressLabel
        singleHistoricLocation
        rgAddressProvider={rgAddressProvider}
      />
    </SingleWrapper>
  );
});

export default SingleHistoricLocation;
